module.exports = __webpack_public_path__ + "static/media/tanque-cheio-de-premios.97f0d4fa.png";